import React, { useState, useContext } from 'react'
import Button from '@material-ui/core/Button'
import TextField from '@material-ui/core/TextField'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import Hidden from '@material-ui/core/Hidden'
import ListItemIcon from '@material-ui/core/ListItemIcon'
import FormControl from '@material-ui/core/FormControl'
import InputLabel from '@material-ui/core/InputLabel'
import Select from '@material-ui/core/Select'
import MenuItem from '@material-ui/core/MenuItem'

import { makeStyles } from '@material-ui/core/styles'

import EmailIcon from '@material-ui/icons/Email'
import PersonIcon from '@material-ui/icons/Person'
import AssignmentIndIcon from '@material-ui/icons/AssignmentInd'
import PhoneIcon from '@material-ui/icons/Phone'
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff'
import VisibilityIcon from '@material-ui/icons/Visibility'

import validate from 'validate.js'

import constraints from '../../../utils/constraints'
import styles from './AddUserDialog.module.css'

import _firebaseContext from '../../../contexts/firebaseContext'
import _appContext from '../../../contexts/appContext'

const useStyles = makeStyles(theme => ({
    // icon: {
    //     padding: '12px'
    // }
}))

const initialState = {
    performingAction: true,
    name: '',
    surname: '',
    phone: '',
    email: '',
    password: '',
    _password: '',
    role: 'user',
    errors: null,
}

export default function AddUserDialog({ handleClose, open }) {
    const [performingAction, setPerformingAction] = useState(true)
    const [name, setName] = useState('')
    const [surname, setSurname] = useState('')
    const [phone, setPhone] = useState('')
    const [email, setEmail] = useState('')
    const [password, setPassword] = useState('')
    const [_password, _setPassword] = useState('')
    const [visibility, setVisibility] = useState(false)
    const [role, setRole] = useState(initialState.role)
    const [errors, setErrors] = useState(null)

    const firebaseContext = useContext(_firebaseContext)
    const appContext = useContext(_appContext)

    const classes = useStyles()


    const handleNameChange = event => {
        setName(event.target.value)
    }
    const handleSurnameChange = event => {
        setSurname(event.target.value)
    }
    const handleMailChange = event => {
        setEmail(event.target.value)
    }
    const handlePasswordChange = event => {
        setPassword(event.target.value)
    }
    const handlePhoneChange = event => {
        setPhone(event.target.value)
    }
    const handleRoleChange = event => {
        setRole(event.target.value)
    }

    const _handleClose = () => {
        handleClose()
        resetValues()
    }

    const resetValues = () => {
        setPerformingAction(initialState.performingAction)
        setName(initialState.name)
        setSurname(initialState.surname)
        setEmail(initialState.email)
        setPhone(initialState.phone)
        setPassword(initialState.password)
        _setPassword(initialState._password)
        setRole(initialState.role)
        setErrors(initialState.errors)
    }

    const handleSave = async event => {
        const fieldsToValidate = {
            email,
            password,
        }

        if (phone.length !== 0) fieldsToValidate.phone = phone

        const errors = validate(fieldsToValidate, {
            email: constraints.email,
            password: constraints.password,
            phone: constraints.phone,
        })

        if (errors) {
            setErrors({
                email: errors.email && errors.email[0],
                password: errors.password && errors.password[0],
                phone: errors.phone && errors.phone[0],
            })
            setPassword('')
        } else {
            setPerformingAction(true)
            setErrors(null)

            const newUser = {
                name: name,
                surname: surname,
                email: email,
                phone: phone,
                role: role,
                password: password,
            }

            setErrors(false)

            const result = await firebaseContext.createUser(newUser)

            if (result.error) {
                if (result.firebaseError !== undefined && result.firebaseError.errorInfo !== undefined) {
                    const code = result.firebaseError.errorInfo.code
                    let reason = code

                    switch (code) {
                        case 'auth/too-many-requests':
                            reason = 'Слишком много запросов'
                            break
                        case 'auth/invalid-email':
                            reason = 'Недопустимый адрес электронной почты'
                            setErrors({
                                email: 'Недопустимый адрес электронной почты',
                            })
                            break
                        case 'auth/invalid-password':
                            reason = 'Недопустимый пароль'
                            setErrors({
                                password: 'Недопустимый пароль',
                            })
                            break
                        case 'auth/email-already-exists':
                            reason = 'Указаная почта уже используется'
                            setErrors({
                                email: 'Указаная почта уже используется',
                            })
                            break
                        case 'auth/insufficient-permission':
                            reason = 'Нет доступа'
                            break
                        case 'auth/internal-error':
                            reason = 'Проблемы с сервером авторизации'
                            break
                        case 'auth/invalid-argument':
                            reason = 'Некорректные данные'
                            break
                        case 'auth/invalid-password':
                            reason = 'Недопустимый пароль'
                            setErrors({
                                password: reason,
                            })
                            break
                        case 'auth/invalid-phone-number':
                            reason = 'Недопустимый номер телефона'
                            setErrors({
                                phone: reason,
                            })
                            break
                        case 'auth/phone-number-already-exists':
                            reason =
                                'Пользователь с указанным номером уже существует'
                            setErrors({
                                phone: reason,
                            })
                            break
                    }
                    result.message = reason
                }
                setPassword('')
            } else {
                _handleClose()
            }

            appContext.snackbar.showSnackbarMsg(result.message)
        }
    }

    return (
        <Dialog
            open={open}
            onClose={_handleClose}
            aria-labelledby="add-user-form"
            maxWidth="sm"
            fullWidth={true}
        >
            <DialogTitle id="add-user-form-title">
                Добавление нового пользователя
            </DialogTitle>
            <DialogContent>
                <List>
                    <ListItem>
                        <Hidden xsDown>
                            <ListItemIcon className={classes.icon}>
                                <PersonIcon />
                            </ListItemIcon>
                        </Hidden>
                        <TextField
                            autoFocus
                            disabled={!performingAction}
                            error={!!(errors && errors.name)}
                            fullWidth
                            label="Имя пользователя"
                            required
                            type="text"
                            value={name}
                            className={styles.textfield}
                            // onKeyDown={(event) => this.handleKeyDown(event, 'first-name')}
                            onChange={handleNameChange}
                        />
                    </ListItem>
                    <ListItem>
                        <Hidden xsDown>
                            <ListItemIcon className={classes.icon}>
                                <PersonIcon />
                            </ListItemIcon>
                        </Hidden>
                        <TextField
                            autoFocus
                            disabled={!performingAction}
                            // error={!!(errors && errors.firstName)}
                            fullWidth
                            label="Фамилия пользователя"
                            required={true}
                            type="text"
                            value={surname}
                            className={styles.textfield}
                            // onKeyDown={(event) => this.handleKeyDown(event, 'first-name')}

                            onChange={handleSurnameChange}
                        />
                    </ListItem>
                    <ListItem>
                        <Hidden xsDown>
                            <ListItemIcon className={classes.icon}>
                                <EmailIcon />
                            </ListItemIcon>
                        </Hidden>
                        <TextField
                            autoFocus
                            disabled={!performingAction}
                            error={!!(errors && errors.email)}
                            fullWidth
                            label="Почта пользователя"
                            required={true}
                            type="email"
                            value={email}
                            className={styles.textfield}
                            // onKeyDown={(event) => this.handleKeyDown(event, 'first-name')}
                            helperText={
                                errors && errors.email ? errors.email : ''
                            }
                            onChange={handleMailChange}
                        />
                    </ListItem>
                    <ListItem>
                        <Hidden xsDown>
                            <ListItemIcon className={classes.icon}>
                                <PhoneIcon />
                            </ListItemIcon>
                        </Hidden>
                        <TextField
                            autoFocus
                            disabled={!performingAction}
                            error={!!(errors && errors.phone)}
                            fullWidth
                            label="Телефон пользователя"
                            required={true}
                            type="phone"
                            value={phone}
                            placeholder="+11234567890"
                            className={styles.textfield}
                            // onKeyDown={(event) => this.handleKeyDown(event, 'first-name')}
                            helperText={
                                errors && errors.phone ? errors.phone : ''
                            }
                            onChange={handlePhoneChange}
                        />
                    </ListItem>
                    <ListItem>
                        <ListItemIcon className={classes.icon}>
                            {visibility ? (
                                <VisibilityIcon />
                            ) : (
                                    <VisibilityOffIcon />
                                )}
                        </ListItemIcon>
                        <TextField
                            autoFocus
                            disabled={!performingAction}
                            error={!!(errors && errors.password)}
                            fullWidth
                            label="Пароль пользователя"
                            required={true}
                            type="password"
                            value={password}
                            className={styles.textfield}
                            // onKeyDown={(event) => this.handleKeyDown(event, 'first-name')}
                            helperText={
                                errors && errors.password ? errors.password : ''
                            }
                            onChange={handlePasswordChange}
                        />
                    </ListItem>
                    <ListItem>
                        <Hidden xsDown>
                            <ListItemIcon className={classes.icon}>
                                <AssignmentIndIcon />
                            </ListItemIcon>
                        </Hidden>
                        <FormControl fullWidth className={styles.textfield}>
                            <InputLabel id="user-role-select-label">
                                Роль
                            </InputLabel>
                            <Select
                                labelId="user-role-select-label"
                                id="user-role-select"
                                value={role}
                                onChange={handleRoleChange}
                            >
                                <MenuItem value={'user'}>user</MenuItem>
                                <MenuItem value={'admin'}>admin</MenuItem>
                                <MenuItem value={'streamer'}>streamer</MenuItem>
                            </Select>
                        </FormControl>
                    </ListItem>
                </List>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} color="primary">
                    Отмена
                </Button>
                <Button onClick={handleSave} color="primary">
                    Сохранить
                </Button>
            </DialogActions>
        </Dialog>
    )
}
